<template>
  <div class="baidu-map-list-template">
    <div class="panel list-panel">
      <ul class="assets">
        <li
          class="asset"
          v-for="item in listData"
          @click="showDetail(item.primarykey)"
        >
          <p class="title">{{ item.assetname }}</p>
          <div class="tags">
            <span class="tag" v-for="tag in item.tagListArray">{{ tag }}</span>
          </div>
          <div class="info">
            <div class="base-info">
              <p class="base-info-item">成交价：{{ item.transAmount }}</p>
              <p class="base-info-item">起始价：{{ item.transStaringprice }}</p>
              <p class="base-info-item">评估价：{{ item.transConsultprice }}</p>
            </div>
            <div class="extra-info">
              <p class="price">{{ item.tranSaverageprice }}/m<sup>2</sup></p>
              <p class="date">{{ item.transDate }}</p>
            </div>
          </div>
        </li>
      </ul>
      <el-pagination
        class="pagination"
        layout="prev, pager, next"
        :current-page="page"
        :total="total"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import list from "../mixin/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin, list],
  data() {
    return {
      initCfg: {
        listApi: "map_getAuctionList"
      }
    };
  },
  methods: {
    uploadList(list) {
      return list.map(item => {
        let {
          taglist,
          amount,
          staringprice,
          consultprice,
          averageprice,
          dealdate
        } = item;

        // 成交价
        let transAmount = amount ? `￥${amount}` : "暂无数据";
        // 起始价
        let transStaringprice = staringprice ? `￥${staringprice}` : "暂无数据";
        // 评估价
        let transConsultprice = consultprice ? `￥${consultprice}` : "暂无数据";
        // 平均价
        let tranSaverageprice = averageprice ? `￥${averageprice}` : "暂无均价";
        // 时间
        let transDate = dealdate ? dealdate.split(" ")[0] : "";

        return {
          ...item,
          tagListArray: taglist ? JSON.parse(taglist) : [],
          transAmount,
          transStaringprice,
          transConsultprice,
          tranSaverageprice,
          transDate
        };
      });
    },

    // 获取详情
    showDetail(id) {
      this.$emit("on-show-detail", { type: "justice", id });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
